<template>
  <div class="pie3d-box" :style="{height: height}">
    <div>
      <div id="pie3d"></div>
      <div class="cur-num"></div>
      <div class="pie-bg" v-show="showPie"></div>
      <div class="pie-light" v-show="showPie"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pie3d",
  props: {
    height: {
      type: String,
      default: "200px"
    },
    chartData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      showPie: false,
      pie: null
    };
  },
  mounted() {
    setTimeout(() => {
      this.initChart();
    }, 800);
  },
  methods: {
    initChart() {
      this.pie = this.$highcharts.chart("pie3d", {
        chart: {
          type: "pie", //饼图
          marginTop: 32,
          marginLeft: -106,
          options3d: {
            enabled: true, //使用3d功能
            alpha: 60, //延y轴向内的倾斜角度
            beta: 0
          },
          backgroundColor: "rgba(0,0,0,0)",
          events: {
            selection: function(e) {
              console.log(e);
            }
          }
        },
        tooltip: {
          enabled: false
        },
        colors: ["#1d89ff", "#eecf50", "#2bbcff", "#85e9ef", "#b7e948"],
        legend: {
          layout: "vertical",
          align: "right",
          itemStyle: {
            color: "#cbeeff",
            fontSize: 12
          },
          symbolRadius: 0,
          itemMarginBottom: 12,
          x: 16,
          y: 16,
          verticalAlign: "middle",
          itemHoverStyle: {
            color: "#ccc"
          },
          floating: true,
          labelFormatter: function() {
            return (
              "<p class='pie3d-legend'>" +
              this.name +
              " <span> " +
              Math.round((this.y / 100) * 100) +
              "%</span></p>"
            );
          }
        },
        title: {
          text: "" //图表的标题文字
        },
        subtitle: {
          text: "" //副标题文字
        },

        plotOptions: {
          pie: {
            animation: false,
            size: 116,
            allowPointSelect: false, //每个扇块能否选中
            cursor: "pointer", //鼠标指针
            depth: 28, //饼图的厚度
            dataLabels: {
              enabled: false //是否显示饼图的线形tip
            },
            showInLegend: true
          },
          series: {
            point: {
              events: {
                mouseOver: function() {
                  document.getElementsByClassName("cur-num")[0].innerHTML =
                    Math.round((this.y / 100) * 100) + "%";
                }
              }
            },
            events: {
              mouseOut: function() {
                document.getElementsByClassName("cur-num")[0].innerHTML = "";
              }
            }
          }
        },
        series: [
          {
            type: "pie",
            name: "", //统一的前置词,非必须
            data: this.chartData
          }
        ]
      });
      document.getElementsByClassName("highcharts-credits")[0].innerHTML = "";
      this.showPie = true;
    }
  }
};
</script>
<style scoped lang="less">
.pie3d-box {
  width: 100%;
  position: relative;
  > div {
    width: 306px;
    height: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -153px;
    margin-top: -100px;
  }
}

#pie3d {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 99;
  left: 0;
  top: 0;
}
.cur-num {
  position: absolute;
  bottom: 130px;
  left: 78px;
  color: @base-text-color;
}
.pie-bg {
  width: 190px;
  height: 95px;
  background: url(../../assets/youkequntihuaxiang/pie-bg.png);
  background-size: 100% 900%;
  animation: bird-slow 1s steps(8) infinite;
  position: absolute;
  bottom: 26px;
  left: 0px;
}
.pie-light {
  width: 169px;
  height: 99px;
  background: url(../../assets/youkequntihuaxiang/pie-light.png);
  background-size: 100% 100%;
  position: absolute;
  bottom: 64px;
  left: 10px;
}
@keyframes bird-slow {
  0% {
    background-position: 0% 0%;
  }
  100% {
    background-position: 0% 100%;
  }
}
@media screen and (max-height: 863px) {
  .pie3d-box {
    > div {
      height: 190px;
    }
  }
  .pie-bg {
    bottom: 21px;
  }
}
</style>
